import { Component, render } from "preact";
import { css } from "emotion";
import { connect } from "react-redux";
import ColorServices from "../../services/ColorServices";
import { max } from "../../utils/CssUtils";

const sizes = {
  large: {
    cursor: "pointer",
    borderRadius: 4,
    height: 40,
    textAlign: "center",
    fontSize: 16,
    padding: "0px 20px",
    fontWeight: 600,
    minWidth: 134,
    [max(600)]: {
      height: 36,
      fontSize: 14
    }
  },

  medium: {
    cursor: "pointer",
    borderRadius: 4,
    height: 36,
    padding: "0px 24px",
    fontSize: 14,
    fontWeight: 600,
    [max(600)]: {
      height: 32
    }
  },

  small: {
    cursor: "pointer",
    borderRadius: 4,
    height: 32,
    padding: "0px 24px",
    fontSize: 14,
    fontWeight: 600
  },

  wide: {
    cursor: "pointer",
    borderRadius: 4,
    height: 36,
    padding: "0px 24px",
    fontSize: 16,
    fontWeight: 600,
    width: "100%"
  }
};

const types = {
  primary: {
    full: {
      border: `${ColorServices.getColor("purple")} 1px solid`,
      backgroundColor: ColorServices.getColor("purple"),
      color: ColorServices.getColor("white"),
      "&:hover": {
        border: `${ColorServices.getColor("purpleMid")} 1px solid`,
        backgroundColor: ColorServices.getColor("purpleMid"),
        color: ColorServices.getColor("white")
      }
    },
    hollow: {
      border: `${ColorServices.getColor("purple")} 1px solid`,
      backgroundColor: ColorServices.getColor("transparent"),
      color: ColorServices.getColor("purple"),
      "&:hover": {
        border: `${ColorServices.getColor("purple")} 1px solid`,
        backgroundColor: ColorServices.getColor("purple"),
        color: ColorServices.getColor("white")
      }
    }
  },
  secondary: {
    full: {
      border: `${ColorServices.getColor("turquoise")} 1px solid`,
      backgroundColor: ColorServices.getColor("turquoise"),
      color: ColorServices.getColor("purpleMid"),
      "&:hover": {
        border: `${ColorServices.getColor("turquoiseMid")} 1px solid`,
        backgroundColor: ColorServices.getColor("turquoiseMid"),
        color: ColorServices.getColor("purpleMid")
      }
    },
    hollow: {
      border: `${ColorServices.getColor("turquoise")} 1px solid`,
      backgroundColor: ColorServices.getColor("transparent"),
      color: ColorServices.getColor("turquoise"),
      "&:hover": {
        border: `${ColorServices.getColor("turquoise")} 1px solid`,
        backgroundColor: ColorServices.getColor("turquoise"),
        color: ColorServices.getColor("purpleMid")
      }
    }
  }
};

class SignUpButton extends Component {
  componentDidMount() {}

  fireOptimizeTrigger = () => {
    const { children } = this.props;
    dataLayer.push({ label: children });
  };

  render() {
    let {
      size = "medium",
      type = "primary",
      style = "full",
      onClick,
      children,
      ariaLabel,
      content: { localeData, referralLink }
    } = this.props;

    const signupLink = referralLink
      ? `${localeData.consoleURL}/signin${referralLink}`
      : `${localeData.consoleURL}/console/dashboard`;

    const sizeSelected = sizes[size];
    const colors = types[type][style];
    const styleObj = {
      ...sizeSelected,
      ...colors
    };

    if (signupLink) {
      return (
        <a href={signupLink} aria-label={ariaLabel}>
          <button
            onClick={() => this.fireOptimizeTrigger}
            className={css(styleObj)}
            aria-hidden
            tabIndex="-1"
          >
            {children}
          </button>
        </a>
      );
    }
    return (
      <button
        onClick={onClick}
        className={css(styleObj)}
        aria-label={ariaLabel}
      >
        {children}
      </button>
    );
  }
}

export default connect(state => {
  return {
    content: state.content,
    referralLink: state.referralLink
  };
}, {})(SignUpButton);
